<template>
  <!-- eslint-disable -->
  <DsInput type="date" v-model="proxy as Date | undefined" :datepicker-config="config" />
  <!-- eslint-enable -->
</template>

<script lang="ts" setup>
import type { DatepickerConfig } from '@demvsystems/design-components';
import { DsInput } from '@demvsystems/design-components';
import type { ComputedRef } from 'vue';
import { computed } from 'vue';

interface Props {
  modelValue: Date | null;
  datepickerConfig?: DatepickerConfig;
  datepickerConfigComputed?: ComputedRef<DatepickerConfig | undefined>;
}

const props = withDefaults(defineProps<Props>(), {
  datepickerConfig: undefined,
  datepickerConfigComputed: () => computed(() => undefined),
});

const emits = defineEmits(['update:modelValue']);

const config = computed(
  () => props.datepickerConfigComputed?.value ?? props.datepickerConfig,
);

const proxy = computed({
  get: () => props.modelValue,
  set: (v) => {
    if (v !== undefined) {
      // we do not care about the current time - we only compare dates, therefor it should be comparable
      v?.setHours(0, 0, 0, 0);
      emits('update:modelValue', v);
    } else {
      emits('update:modelValue', null);
    }
  },
});
</script>

<script lang="ts">
export default {
  name: 'DatepickerInput',
};
</script>
